import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import { useEffect, useState } from "react";
import { ContactApi } from "./services/api/ContactApi";
import useAuth from "./hooks/useAuth";
import useContact from "./hooks/useContact";
import AppIntroLoading from "./components/AppIntroLoading";
import useReference from "./hooks/useReference";
import { ReferenceApi } from "./services/api/ReferenceApi";
import { Ica } from "./models/Ica";

const Wrapper = () => {
  const { currencyList, setCurrencyList } = useReference();
  const { token } = useAuth();
  const { setPrograms, setIcas, setDevelopers } = useContact();
  const [isLoading, setIsLoading] = useState(false);
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    if (token) {
      setIsLoading(true);

      ContactApi.getPrograms()
        .then((res) => {
          const programs = res.data;
          programs.sort((a, b) =>
            a.name.localeCompare(b.name, "en", { sensitivity: "base" })
          );
          setPrograms(programs);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      if (currencyList && currencyList.length > 0) {
        return;
      } else {
        setIsLoading(true);
        ReferenceApi.getCurrencies()
          .then((res) => {
            setCurrencyList(res.data);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      setIsLoading(true);

      ContactApi.getIcas()
        .then((res) => {
          const icas = res.data as Ica[];
          icas.sort((a, b) =>
            a.description.localeCompare(b.description, "en", {
              sensitivity: "base",
            })
          );
          const distinctArray = Array.from(
            icas
              .reduce(
                (map, obj) => map.set(obj.icaValue, obj),
                new Map<string, Ica>()
              )
              .values()
          );
          setIcas(distinctArray);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      setIsLoading(true);

      ContactApi.getDevelopers()
        .then((res) => {
          const developers = res.data;
          developers.sort((a, b) =>
            a.name.localeCompare(b.name, "en", { sensitivity: "base" })
          );
          setDevelopers(developers);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [token]);
  
  return (
    <>
      <Header />
      <Outlet />
      {showIntro && (
        <AppIntroLoading
          isLoading={isLoading}
          onComplete={() => setShowIntro(false)}
        />
      )}
    </>
  );
};

export default Wrapper;
